import { render, staticRenderFns } from "./projectTaxes.vue?vue&type=template&id=02bde304&scoped=true&"
import script from "./projectTaxes.vue?vue&type=script&lang=js&"
export * from "./projectTaxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bde304",
  null
  
)

export default component.exports